import { defineMessages } from 'react-intl';

const messages = defineMessages({
  totalArea: {
    id: 'general.totalArea',
    defaultMessage: 'Total area',
    description: 'Total area',
  },
  fuel: {
    id: 'general.fuel',
    defaultMessage: 'Fuel',
    description: 'Fuel',
  },
  effectiveTotalDistance: {
    id: 'general.effectiveTotalDistance',
    defaultMessage: 'Effective Total Distance',
    description: 'Effective Total Distance',
  },
  ineffectiveTotalDistance: {
    id: 'general.ineffectiveTotalDistance',
    defaultMessage: 'Ineffective Total Distance',
    description: 'Ineffective Total Distance',
  },
  effectiveTotalTime: {
    id: 'general.effectiveTotalTime',
    defaultMessage: 'Effective Total Time',
    description: 'Effective Total Time',
  },
  ineffectiveTotalTime: {
    id: 'general.ineffectiveTotalTime',
    defaultMessage: 'Ineffective Total Time',
    description: 'Ineffective Total Time',
  },
  totalFuelConsumption: {
    id: 'general.totalFuelConsumption',
    defaultMessage: 'Total Fuel Consumption',
    description: 'Total Fuel Consumption',
  },
  yieldTotalMass: {
    id: 'general.yieldTotalMass',
    defaultMessage: 'Yield Total Mass',
    description: 'Yield Total Mass',
  },
});

export default messages;
